import React from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "../LayoutAdmin/Sidebar";
import Announcements from "../Pages/Announcements";
import AddAnnouncements from "../Pages/Announcements/AddAnnouncements";
import EditAnnouncements from "../Pages/Announcements/EditAnnouncements";
import Applicant from "../Pages/Applicant";
import ViewApplicant from "../Pages/Applicant/viewApplicant";
import Certificates from "../Pages/Certificates";
import AddCertificates from "../Pages/Certificates/AddCertificates";
import EditCertificates from "../Pages/Certificates/EditCertificates";
import Events from "../Pages/Events";
import AddEvents from "../Pages/Events/AddEvents";
import EditEvents from "../Pages/Events/EditEvents";
import Gallery from "../Pages/Gallery";
import AddGallery from "../Pages/Gallery/AddGallery";
import EditGallery from "../Pages/Gallery/EditGallery";

import Home from "../Pages/Home";
import Login from "../Pages/login";
import SendNotification from "../Pages/SendNotification";
import Sponsers from "../Pages/Sponsers";
import AddSponsers from "../Pages/Sponsers/AddSponsers";
import EditSponsers from "../Pages/Sponsers/EditSponsers";
import StartQuiz from "../Pages/startQuiz";
import Bulletins from "../Pages/Bulletin";
import AddBulletins from "../Pages/Bulletin/AddBulletin";
import EditBulletins from "../Pages/Bulletin/EditBulletin";
import AddApplicant from "../Pages/Applicant/addApplicant";

function AdminRoute() {
  return (
    <Routes>
      <Route path="/" element={<Sidebar />}>
        <Route index element={<Home />} />
        <Route path="/announcements" element={<Announcements />} />
        <Route path="/announcements/create" element={<AddAnnouncements />} />
        <Route path="/announcements/edit/:id" element={<EditAnnouncements />} />
        <Route path="/sponsers" element={<Sponsers />} />
        <Route path="/sponsers/create" element={<AddSponsers />} />
        <Route path="/sponsers/edit/:id" element={<EditSponsers />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/create" element={<AddEvents />} />
        <Route path="/events/edit/:id" element={<EditEvents />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/certificates/create" element={<AddCertificates />} />
        <Route path="/certificates/edit/:id" element={<EditCertificates />} />
        <Route path="/sendNotification" element={<SendNotification />} />
        <Route path="/applicant" element={<Applicant />} />
        <Route path="/applicant/view/:id" element={<ViewApplicant />} />
        <Route path="/applicant/create" element={<AddApplicant />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/create" element={<AddGallery />} />
        <Route path="/gallery/edit/:id" element={<EditGallery />} />
        <Route path="/start_quiz" element={<StartQuiz />} />

        {/* Bulletin Route */}
        <Route path="/bulletin" element={<Bulletins />} />
        <Route path="/bulletin/create" element={<AddBulletins />} />
        <Route path="/bulletin/edit/:id" element={<EditBulletins />} />


      </Route>
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}

export default AdminRoute;
